import { render, staticRenderFns } from "./cAssignReviewGroup.vue?vue&type=template&id=61cc6cfe&scoped=true"
import script from "./cAssignReviewGroup.vue?vue&type=script&lang=js"
export * from "./cAssignReviewGroup.vue?vue&type=script&lang=js"
import style0 from "./cAssignReviewGroup.vue?vue&type=style&index=0&id=61cc6cfe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61cc6cfe",
  null
  
)

export default component.exports